import { Alert } from "react-native";

export const handleApiResponse = {
    handleResponse: (response) => {
        return response.text().then(text => {
            let data = null;

            if (text) {
                try {
                    data = JSON.parse(text);
                } catch (error) {
                    const isHtmlResponse = text.trim().startsWith('<');
                    const fallbackMessage = isHtmlResponse
                        ? 'The server returned an unexpected HTML response.'
                        : 'The server returned an invalid response.';

                    if (!response.ok) {
                        return Promise.reject(fallbackMessage);
                    }

                    return Promise.reject(fallbackMessage);
                }
            }

            if (!response.ok) {
                if (response.status === 403) {
                    Alert.alert('Unauthrised')
                }
                const error = (data && data.message) || response.statusText;
                return Promise.reject(error);
            }
            return data;
        });
    },
    handleLogout: () => {
        Alert.alert('Replace auth token')
    }
}
